export default [
  'diego@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'adriana.molvinger@foodforjoe.es',
  'albane@foodforjoe.es',
  'josep@foodforjoe.es',
  'dana@foodforjoe.es',
  'data@foodforjoe.com',
  'tania@foodforjoe.es',
  'jonathan@foodforjoe.com',
];
